import React from 'react';
import { ChannelType } from '../../../../types/channel';
import { MeterConfigurationForm } from './components/configuration-form/configuration-form';
import MeterConfigurationProvider from './context';

type MeterConfigurationProps = {
  channel: ChannelType;
};

export const MeterConfiguration: React.FC<MeterConfigurationProps> = ({ channel }) => (
  <MeterConfigurationProvider>
    <MeterConfigurationForm channel={channel} />
  </MeterConfigurationProvider>
);
